module.exports = __webpack_public_path__ + "img/79.e2798873.png";